class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden', 'cart-drawer-open');

    // update shipping bar when cart is opened
    this.updateFreeShippingBar();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //this.updateFreeShippingBar(); // update shipping bar when cart is updated
      this.open();
    });
  }

  // Update the free shipping bar when the cart is opened or updated
  updateFreeShippingBar(cart = null) {
  // console.log('updateFreeShippingBar', cart);
  // console.log('renderFreeShipping', cart?.total_price ?? 'no total_price');
  if(cart) {
    this.renderFreeShipping(cart);
    return;
  }
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => this.renderFreeShipping(cart));

  }

  renderFreeShipping(cart) {
      const wrapper = this.querySelector('.drawer__header-free-shipping-progress');
      if (!wrapper) return;

      const message = wrapper?.querySelector('.free-shipping-message');
      const fill = wrapper?.querySelector('.free-shipping-bar-fill');

      if (!message || !fill) return;

      const isAU = Shopify.country === 'AU';

      const thresholdAUD = isAU ? Number(wrapper.dataset.auThreshold) : Number(wrapper.dataset.intThreshold);

      const rate = parseFloat(Shopify.currency.rate || 1);

      const threshold = thresholdAUD * rate;

      const subtotal = cart.total_price / 100;

      if (typeof cart.total_price === 'undefined') {
        console.error('Missing total_price in cart object', cart);
        return;
      }

      const remaining = Math.max(0, threshold - subtotal);

      const percent = Math.min((subtotal / threshold) * 100, 100);

      const formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: Shopify.currency.active,
        currencyDisplay: 'narrowSymbol'
      });

      const formattedRemaining = formatter.format(remaining).replace(/\s+/g, '');

      if (remaining <= 0) {
        message.innerHTML =
          '🎉 <strong>Congrats! Free Shipping Unlocked!</strong>';
      } else {
        message.innerHTML =
          `<span>Spend <strong>${formattedRemaining}</strong> more for <strong>FREE SHIPPING</strong></span>`;
      }

      fill.style.width = percent + '%';
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
